export default __webpack_public_path__ + "media/hamilton-lib-logo.f0c779ea.PNG";